import React from "react"
import { H2, ArrowLink } from "@carrotfertility/carotene"
import { HomeCard } from "components/views/home/Home"
import { FormattedMessage } from "react-intl"
import { Box, useTheme } from "@carrotfertility/carotene-core"

export default function ReadAndLearnEligibilityModule(): JSX.Element {
  const theme = useTheme()
  return (
    <HomeCard>
      <Box marginBottom={theme.spacing(theme.tokens.spacing.xxs)}>
        <H2>
          <FormattedMessage defaultMessage="Read & learn" />
        </H2>
      </Box>
      <Box marginBottom={theme.spacing(theme.tokens.spacing.md)}>
        <span className="publico-text fw4 lh-copy black-80">
          <FormattedMessage defaultMessage="Explore articles and videos on a wide range of topics." />
        </span>
      </Box>
      <ArrowLink to="/read">
        <FormattedMessage defaultMessage="Start learning" />
      </ArrowLink>
    </HomeCard>
  )
}
